import scrollTo from '~/lib/scrollTo';
import { hideInvoicesInfo } from '~/lib/handleFooter';

export default {
  namespaced: true,
  state: {},
  actions: {
    scrollTo(_, val) {
      scrollTo(val);
    },
    scrollToElement(_, el) {
      const rect = el.getBoundingClientRect();

      scrollTo({
        top: rect.top + window.scrollY - 80,
        left: rect.left + window.scrollX,
      });
    },
    hideFooterInvoicesInfo() {
      hideInvoicesInfo();
    },
  },
};
